<!-- 校友分会--校友成员 -->
<template>
  <div class="alumniResourcesBox">
    <div class="resources-list-box">
      <template v-if="alumnusList.length > 0">
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
        >
          <template v-for="item in alumnusList" class="alumni-card-box">
            <alumni-info-card :info="item" @go="goAlumniDetail" />
          </template>
        </van-list>
      </template>
      <div v-else>
        <van-empty description="没有发现校友" />
      </div>
    </div>
  </div>
</template>

<script>
import AlumniInfoCard from "./components/AlumniMembers/alumniComponents.vue";
import Base64 from "@/utils/base64";
export default {
  components: {
    AlumniInfoCard,
  },
  data() {
    return {
      searchData: {
        userId: window.localStorage.getItem("user_id"),
        schoolBranchId: this.$route.query.schoolBranchId,
        name: null,
        currentPage: 1,
        pageSize: 10,
        bigShot: 0,
      },
      alumnusList: [], // 校友列表
      total: 0,
      loading: false,
      finished: false,
      alumnusLastPage: "", // 最后一页
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      let base64 = new Base64()
      console.log("校友分会--校友成员-列表", this.$route.query.schoolBranchId);
      const res = await this.$http.get("/branch/getBranchInDetail", {
        params: {userId: base64.encode(this.searchData.userId),schoolBranchId: this.searchData.schoolBranchId},
        // params: {userId: "43995354",schoolBranchId: this.searchData.schoolBranchId},
      });
      res.data.member.forEach((item) => {
        item.isOpen = false;
        return item;
      });
      for (let i = 0; i < res.data.member.length; i++) {
        this.alumnusList.push(res.data.member[i]);
      }
    },

    goAlumniDetail(e) {
      console.log("e", e);
      return this.$router.push({
        path: "/alumniDetailNew",
        query: { alumniId: e },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.alumniResourcesBox {
  position: relative;
  width: 100%;

  .filter-dropdown {
    position: fixed;
    top: 45px;
    left: 0;
    width: 100vw;
    z-index: 9999;

    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
      // border: 1px solid #888;
    }
  }

  .resources-list-box {
    padding: 2.666667vw;
    // margin-top: 50px;
    //background-color: #e7c6c6;
  }
}

.van-sidebar-item--select::before {
  background-color: #00706e !important;
}

.van-tree-select__item--active {
  color: #00706e;
}

.van-button--danger {
  color: #fff;
  background-color: #00706e;
  border: 1px solid #00706e;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniMeeting/AlumniMembers.vue